module.exports = __webpack_public_path__ + "res/up_down_arrow.png";